import React, { useState } from 'react';
import { Box, TextField, Select, MenuItem, Button, Typography, Card, CardContent, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../context/ToastContext';

const WithdrawCreditPage = () => {

  // path="/user/:id/:app/transfer"
  const { id, app } = useParams();
  const { postWithdrawCredits } = useAppContext();
  const { showCorrect, showError } = useToast();
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [application, setApplication] = useState('');


  const handleTransfer = async () => {

    await postWithdrawCredits(id, app, amount)
  
  };

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>Withdraw Credit</Typography>
          
          <Stack spacing={2}>
            <TextField
              label="Amount"
              type="number"
              fullWidth
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={handleTransfer}
              fullWidth
            >
              Transfer Credits
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default WithdrawCreditPage;
